
export type ImageryProviderId =
    | "sps"
    | "sh"

export const providers = {

    sps: {
        name: "SpaceSense",
    },

    sh: {
        name: "SentinelHub"
    }

} as const


